import { render, staticRenderFns } from "./UiSwitcher.vue?vue&type=template&id=12e3e5fa"
import script from "./UiSwitcher.vue?vue&type=script&lang=js"
export * from "./UiSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12e3e5fa')) {
      api.createRecord('12e3e5fa', component.options)
    } else {
      api.reload('12e3e5fa', component.options)
    }
    module.hot.accept("./UiSwitcher.vue?vue&type=template&id=12e3e5fa", function () {
      api.rerender('12e3e5fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui-switcher/UiSwitcher.vue"
export default component.exports